import HTTPService from '../HTTPService'
import PrepareDataForMessage from './PrepareDataForMessage'

class MessageTemplates extends PrepareDataForMessage {
  getAll (companySlug, scenarioSlug, stepId) {
    return HTTPService.get(`company/${companySlug}/scenario/${scenarioSlug}/step/${stepId}/message`)
  }

  addOne (companySlug, scenarioSlug, stepId, payload) {
    const payloadData = this.prepareData(payload)

    return HTTPService.post(`company/${companySlug}/scenario/${scenarioSlug}/step/${stepId}/message`, payloadData)
  }

  getOne (companySlug, scenarioSlug, stepId, messageId) {
    return HTTPService.get(`company/${companySlug}/scenario/${scenarioSlug}/step/${stepId}/message/${messageId}`)
  }

  updateOne (companySlug, scenarioSlug, stepId, messageId, payload) {
    const payloadData = this.prepareData(payload)

    return HTTPService.put(`company/${companySlug}/scenario/${scenarioSlug}/step/${stepId}/message/${messageId}`, payloadData)
  }

  deleteOne (companySlug, scenarioSlug, stepId, messageId) {
    return HTTPService.delete(`company/${companySlug}/scenario/${scenarioSlug}/step/${stepId}/message/${messageId}`)
  }

  sort (companySlug, scenarioSlug, stepId, payload) {
    return HTTPService.post(`company/${companySlug}/scenario/${scenarioSlug}/step/${stepId}/message/sort`, {
      messages: payload.messages // {id: Number, order: Number}[]
    })
  }
}

export default new MessageTemplates()
